import { FC, ReactNode } from 'react';
import { Box, useTheme, useMediaQuery, Divider } from '@mui/material';

interface LockedDashboardProps {
  title: ReactNode;
  content: ReactNode;
  images: ReactNode;
}

const LockedDashboard: FC<LockedDashboardProps> = (props) => {
  const { title, content, images } = props;
  const theme = useTheme();
  const isSmallDevice = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box
      sx={{
        background: 'linear-gradient(180.58deg, #51B8B040 -37.91%, #FFFFFF 89.29%)',
        border: '3px solid #E8EAEB',
        borderRadius: '12px',
        padding: '2rem',
        display: 'flex',
        flexDirection: 'column',
        gap: '2rem',
      }}
    >
      <Box
        sx={{
          height: '100%',
          width: '100%',
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'space-between',
          flexDirection: isSmallDevice ? 'column' : 'row',
          gap: '2rem',
        }}
      >
        {/* Icon and Message Box */}
        <Box
          sx={{
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            justifyContent: 'center',
            minWidth: isSmallDevice ? '100%' : '50%',
            maxWidth: isSmallDevice ? '100%' : '50%',
          }}
        >
          {/* Title Section */}
          {title}
        </Box>

        {/* Locked Preview Image */}
        <Box
          sx={{
            borderRadius: '12px',
            display: 'flex',
            justifyContent: 'flex-end',
            overflow: 'hidden',
          }}
        >
          {images}
        </Box>
      </Box>
      <Divider />
      {/* Content Section */}
      {content}
    </Box>
  );
};

export default LockedDashboard;
